import { CustomDetailEnum } from '@dealstack/shared/lib/generated/models/CustomDetailEnum.ts';

//TODO REFACTOR move this to frontend shared folder - D.Zghinnik
export const CUSTOM_DETAIL_TYPE_OPTIONS = Object.values(CustomDetailEnum);

export const INDIVIDUAL_DETAILS_DEFAULT_CHIPS = [
	'Name',
	'Address',
	'Date of birth',
	'Email',
	'Phone number',
];
export const VEHICLE_DETAILS_DEFAULT_CHIPS = [
	'Name of Personal Investment Vehicle',
	'Corporate registration number',
	'Address',
	'Legal representative',
];
